import React, {Component} from 'react';
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {history} from "../../history/History";
import blackLogo from "../../images/logo-black.png"
import {NavLink} from "react-router-dom";

class HeaderApp extends Component {

    render() {
        return (
            <div className="home-header">
                {this.props.profile && <div>
                    <span>{!this.props.name ? 'Hello @' + this.props.profile.username + '!' : this.props.name}</span>
                    <button className="back"
                            onClick={() => this.props.back ? history.push(this.props.back) : history.goBack()}>
                        <i className="icon-arrow_back_ios black-text"/>
                    </button>
                    <NavLink to="/hom">
                        <img src={blackLogo} alt=""/>
                    </NavLink>
                </div>}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        profile: state.param[Objects.profile],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderApp)
